module.exports = __webpack_public_path__ + "img/mk-生物学@2x.fe95563f.png";